import { apiProductNatures } from '@spo/services/api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { sleep } from '../utils/sleep';

export const useProductNatures = (
  sportIds: number[],
  search: string,
  debounce = false,
) => {
  return useQuery({
    queryKey: ['useProductNatures', sportIds, search],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(500);
      }
      if (!signal?.aborted) {
        let response;
        if (sportIds.length > 0) {
          response = await apiProductNatures.getProductNatures({
            sportIds,
            language: 'EN',
            search: '',
            status: 'active',
            startRange: 0,
            endRange: 29,
          });
        } else {
          response = await apiProductNatures.getProductNaturesReferentialByIds({
            productNatureIds: [],
            language: 'EN',
            search,
          });
        }
        return response;
      }
    },
    placeholderData: keepPreviousData,
  });
};

export const useNaturesArchitectureTable = (sportId: number) => {
  return useQuery({
    queryKey: ['useNaturesArchitectureTable', sportId],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = await apiProductNatures.getNaturesArchitectureTable({
          sportId,
          language: 'EN',
        });
        return response;
      }
    },
  });
};

export const useProductNatureData = (
  natureId: string | null,
  sportId: number,
) => {
  return useQuery({
    queryKey: ['useProductNatureData', natureId, sportId],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted && natureId && sportId) {
        const response = await apiProductNatures.getFullProductNature({
          natureId,
          sportId,
          language: 'EN',
        });
        return response;
      }
    },
    enabled: Boolean(natureId) && Boolean(sportId),
  });
};
